import React from 'react';
// Styles for CustomToggle are now in App.scss

interface CustomToggleProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  id: string;
}

const CustomToggle: React.FC<CustomToggleProps> = ({ checked, onChange, id }) => (
  <>
    <input
      type="checkbox"
      id={id}
      checked={checked}
      onChange={onChange}
      className="customToggleInput"
    />
    <label htmlFor={id} className="customToggleSwitch"></label>
  </>
);

export default CustomToggle; 